<template>
  <div
    class="country-card card-condition connection-type"
    :class="{
      noteq: value === 'IS_NOT_PROXY',
      'card-condition__planLimits': hasPlanLimitsRestriction('proxyCondition'),
    }"
  >
    <ui-tooltip-icon
      v-if="hasPlanLimitsRestriction('proxyCondition')"
      class="card-condition__planLimits--tooltip"
      preset="error"
      :text="t('This option is no longer active due to the subscription change to the plan which doesn’t include this option or this add-on is switched off in your subscriptions settings.')"
    />
    <ui-icon @click="emit('close')" size="12" icon="fas fa-times" class="card-condition__close"></ui-icon>
    <ui-radio-group style-type="inline" v-model="value" :label="t('Proxy')">
      <div class="d-flex align-baseline ml-16">
        <ui-radio value="IS_PROXY" :label="t('Is Proxy')" />
        <ui-radio class="ml-16" value="IS_NOT_PROXY" :label="t('Not Proxy')" />
      </div>
    </ui-radio-group>
  </div>
</template>

<script setup lang="ts">
import { useFlowSingleValueCondition } from './useFlowSingleValueCondition';

const props = defineProps<{
  conditions: Record<string, { predicate: string; values: string }>;
}>();

const emit = defineEmits<{
  close: [];
}>();

const { t, value, hasPlanLimitsRestriction } = useFlowSingleValueCondition(props.conditions, {
  conditionKey: 'proxy',
  defaultValue: 'IS_NOT_PROXY',
  planLimitsKey: 'proxyCondition',
});
</script>
